import React from 'react';
import { Calendar, MapPin, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const GuinnessRecords = () => {
  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/records" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Records</span>
        </Link>
        <h1 className="heading-1" style={{ marginBottom: '40px', textAlign: 'center' }}>GUINNESS WORLD RECORDS</h1>
        
        <div style={{ maxWidth: '1000px', margin: '0 auto', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-medium)', borderRadius: '16px', padding: '50px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'inline-block', backgroundColor: '#ffd700', color: '#000', padding: '8px 20px', borderRadius: '25px', fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '20px' }}>
              🏆 GUINNESS WORLD RECORD
            </div>
            <h2 className="heading-2" style={{ color: '#ffd700', fontSize: '2rem', marginBottom: '10px' }}>THICKEST BOOK IN THE WORLD</h2>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px', marginBottom: '40px' }}>
            <img src="/records/guinness/thickest-book-1.jpg" alt="Guinness Record 1" style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} />
            <img src="/records/guinness/thickest-book-2.png" alt="Guinness Record 2" style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} />
            <img src="/records/guinness/thickest-book-3.png" alt="Guinness Record 3" style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} />
            <img src="/records/guinness/thickest-book-4.jpg" alt="Guinness Record 4" style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} />
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'center', gap: '50px', marginBottom: '40px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
              <Calendar size={22} color="var(--brand-primary)" />
              <span style={{ fontWeight: '600', fontSize: '1rem' }}>26 JULY 2023</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
              <MapPin size={22} color="var(--brand-primary)" />
              <span style={{ fontWeight: '600', fontSize: '1rem' }}>Chennai</span>
            </div>
          </div>
          
          <div style={{ backgroundColor: 'var(--bg-page)', padding: '30px', borderRadius: '12px', border: '1px solid var(--border-medium)' }}>
            <p className="body-medium" style={{ lineHeight: '1.8', textAlign: 'justify', fontSize: '1.1rem', margin: 0 }}>
              ESN Publications, in collaboration with the London Organisation of Skills Development Ltd, holds the Guinness World Record for the thickest unpublished book. The book, which contains 100,100 pages and measures 5.80 meters (19 ft 0.34 in) in thickness, was created to promote reading and writing. It includes research papers from universities in India and the UK.
            </p>
            <div style={{ marginTop: '24px', textAlign: 'center' }}>
              <a
                href="https://www.guinnessworldrecords.com/world-records/thickest-book-unpublished"
                target="_blank"
                rel="noreferrer noopener"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '14px 28px',
                  borderRadius: '9999px',
                  backgroundColor: '#ffb703',
                  color: '#102a43',
                  fontWeight: '700',
                  textDecoration: 'none',
                  boxShadow: '0 12px 30px rgba(255, 181, 3, 0.2)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
                onMouseEnter={(event) => { event.currentTarget.style.transform = 'translateY(-2px)'; event.currentTarget.style.boxShadow = '0 18px 40px rgba(255, 181, 3, 0.28)'; }}
                onMouseLeave={(event) => { event.currentTarget.style.transform = 'translateY(0)'; event.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 181, 3, 0.2)'; }}
              >
                View Official Record
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default GuinnessRecords;